import {
  GSKInstance,
  HexalInstance,
  IncyteInstance,
  NovartisInstance,
  SeqirusInstance,
} from '@common/enums';
import { Languages } from './languages';

const MED_INFO_CONTENT: Record<string, Record<Languages, string>> = {
  [IncyteInstance.Default]: {
    [Languages.EN]: '',
    [Languages.DE]: `
Medizinische Anfragen oder Meldungen zu unerwünschten Ereignissen können jederzeit über die folgenden Kontaktdaten gemeldet werden.\n\nIncyte Biosciences  \nMedical Information Center  \nTel: [+49 (0) 800 100 96 33](tel:+498001009633)  \nE-Mail: [eumedinfo@incyte.com](mailto:eumedinfo@incyte.com)\n\n[Weitere Informationen](https://incyte.com/contact-us/medical-information)
`,
  },
  [IncyteInstance.Derma]: {
    [Languages.EN]: '',
    [Languages.DE]: `
Medizinische Anfragen oder Meldungen zu unerwünschten Ereignissen können jederzeit über die folgenden Kontaktdaten gemeldet werden.\n\nIncyte Biosciences  \nMedical Information Center  \nTel: [+49 (0) 800 100 96 33](tel:+498001009633)  \nE-Mail: [eumedinfo@incyte.com](mailto:eumedinfo@incyte.com)\n\n[Weitere Informationen](https://incyte.com/contact-us/medical-information)
`,
  },
  [IncyteInstance.Onko]: {
    [Languages.EN]: '',
    [Languages.DE]: `
Medizinische Anfragen oder Meldungen zu unerwünschten Ereignissen können jederzeit über die folgenden Kontaktdaten gemeldet werden.\n\nIncyte Biosciences  \nMedical Information Center  \nTel: [+49 (0) 800 100 96 33](tel:+498001009633)  \nE-Mail: [eumedinfo@incyte.com](mailto:eumedinfo@incyte.com)\n\n[Weitere Informationen](https://incyte.com/contact-us/medical-information)
`,
  },
  [HexalInstance.Default]: {
    [Languages.EN]: '',
    [Languages.DE]: `
Hexal AG  \nMedizinischer Infoservice  \nMo. - Do. von 8 - 17 Uhr, Fr. von 8 - 13 Uhr  \nTel: [\\+49 (0) 800 439 25 27](tel:+498004392527)  \nE-Mail: [medwiss@hexal.com](mailto:medwiss@hexal.com)
`,
  },
  [NovartisInstance.Default]: {
    [Languages.EN]: '',
    [Languages.DE]:
      'Novartis Pharma GmbH  \nMedizinischer InfoService  \nTel: [+49 (0) 911 273 12 100](tel:+4991127312100)*  \nLive Chat: [chat.novartis.de](https://chat.novartis.de)*  \nE-Mail: [infoservice.novartis@novartis.com](mailto:infoservice.novartis@novartis.com)  \nKontaktformular: [infoservice.novartis.de](https://klinischeforschung.novartis.de/infoservice/#modal-kontaktformular)\n\n*Mo. - Fr. von 8 - 18 Uhr',
  },
  [GSKInstance.Default]: {
    [Languages.EN]: '',
    [Languages.DE]: `
GlaxoSmithKline GmbH & Co. KG  \nMo. - Fr. von 8 - 17 Uhr  \nTel: [+49 (0) 800 1 22 33 55](tel:+498001223355) (gebührenfrei)\n\n[Kontaktanfragen](https://medical.gsk.com/de-de/kontakt/kontaktanfrage)
`,
  },
  [SeqirusInstance.Default]: {
    [Languages.EN]: '',
    [Languages.DE]: `
Seqirus GmbH  \nStefan-George-Ring 23  \n81929 München  \nTel.: [0800 3601010](tel:08003601010)  \nFax: [0800 3601011](fax:08003601011)  \nE-Mail: [ccc@seqirus.com](mailto:ccc@seqirus.com)\n\n[Medizinische Anfragen](https://www.cslseqirus.de/kontakt)
`,
  },
};

export default MED_INFO_CONTENT;
